import { call, put, takeLatest } from 'redux-saga/effects';
import { Types, submitMFASuccess, submitMFAFail } from './actions';
import { handlePostCognitoLogin } from '../authSharedSagas';
import { cognitoRespondToMFAChallenge } from '@services/cognitoUserService';
import { getCognitoMfaErrorI18nKey } from '@services/cognitoErrorNormalizer';
import { postPasswordChangedAtWithToken } from '@services/authenticationService';
import { setRedirectUrl } from '@containers/App/components/Redirector/actions';
import { LOCAL_STORAGE_ITEM, setToLocalStorage } from '@utils/localStorageHelper';
import { ROUTES } from '@shared/constants';

const toMfaUiError = (err, fallbackI18nKey = 'Errors.mfa.signInFailed') => {
  const i18nKey = getCognitoMfaErrorI18nKey(err);
  return { i18nKey: i18nKey || fallbackI18nKey };
};

function* submitMFASaga(action) {
  try {
    const { username, code, session, challengeName, shouldSyncPasswordChangedAt } = action.payload;
    const result = yield call(cognitoRespondToMFAChallenge, { username, code, session, challengeName });
    if (result.success) {
      // After successful MFA, do the same as a successful login
      // Use the shared post-login handler
      const cognitoSub = result.user?.getIdToken?.().payload?.sub || username;
      const token = result.user?.getAccessToken?.().getJwtToken?.();
      if (shouldSyncPasswordChangedAt && token) {
        try {
          yield call(postPasswordChangedAtWithToken, token);
        } catch (_) {
          // ignore
        }
      }
      const user = yield* handlePostCognitoLogin({
        cognitoSub,
        token,
        email: username,
      });
      if (user) {
        yield put(submitMFASuccess(user));
      } else {
        yield put(submitMFAFail({ i18nKey: 'Errors.mfa.missingSession' }));
      }
    } else if (result?.challenge === 'NEW_PASSWORD_REQUIRED') {
      setToLocalStorage(LOCAL_STORAGE_ITEM.COGNITO_NEW_PASSWORD_CHALLENGE, result?.payload);
      yield put(setRedirectUrl(ROUTES.RESET_PASSWORD, {
        reason: 'passwordExpired',
      }));
    } else {
      yield put(submitMFAFail(toMfaUiError(result.error)));
    }
  } catch (error) {
    yield put(submitMFAFail(toMfaUiError(error)));
  }
}

export default function* mfaVerificationSaga() {
  yield takeLatest(Types.SUBMIT_MFA, submitMFASaga);
}
